import { type EntityId, isCompanyId, isTeamId, type TinyEntitlement } from '@terros/common'

export const ENTITLEMENT_SOURCE = ['user', 'company', 'team', 'purchased', 'trial'] as const
export type EntitlementSource = (typeof ENTITLEMENT_SOURCE)[number]

export const getEntitlementSource = (entitlement: TinyEntitlement): EntitlementSource => {
  if (entitlement.source === 'revenuecat') return 'purchased'
  if (entitlement.source === 'trial') return 'trial'
  if (isCompanyId(entitlement.source)) return 'company'
  if (isTeamId(entitlement.source)) return 'team'
  return 'user'
}

export const isDirectEntitlement = (entitlement: TinyEntitlement, entityId: EntityId): boolean =>
  entitlement.source === entityId

export const groupEntitlementsBySource = (detailed: TinyEntitlement[]): Map<EntitlementSource, TinyEntitlement[]> => {
  const grouped = new Map<EntitlementSource, TinyEntitlement[]>()
  for (const entry of detailed) {
    const source = getEntitlementSource(entry)
    const list = grouped.get(source) ?? []
    list.push(entry)
    grouped.set(source, list)
  }
  return grouped
}
